/* src/app/auth/components/login-form/login-form.component.scss */
:host {
  display: flex;
  justify-content: center;
}
.login-form {
  width: 350px;
}
@media (max-width: 767.98px) {
  .login-form {
    width: 100%;
  }
}
.login-form .mat-form-field {
  width: 100%;
}
.login-form .phone-field-container {
  display: flex;
}
.login-form .phone-field-container .prefix-field {
  width: 57px;
  margin-right: 5px;
}
.login-form .password-field {
  padding-bottom: 12px;
}
.login-form .password-field .hide-password-icon {
  cursor: pointer;
  position: relative;
  top: 0;
  left: 3px;
}
/*# sourceMappingURL=login-form.component.css.map */
